export default __webpack_public_path__ + "images/ee311af1445da2476f8cb5b6a7548e37-plane-level-pos.png";